import { DirtyProvider } from '../../hooks/useDirtyProvider';
import { DisabledPrinterProvider } from '../../hooks/useIsDisabledPrinter';
import { useOfflineRedirect } from '../../hooks/useOfflineRedirect';
import { useIsOnline } from '../../hooks/useIsOnline';
import type { ReactNode } from 'react';
import Header from '../header';
import SSCCOfflineCard from '../cards/SSCCOfflineCard';
import { QmDetailsDialogProvider } from '../../contexts/QmDetailsDialogContext';

type LayoutProps = {
  children: ReactNode;
};

export default function Layout({ children }: LayoutProps) {
  const { isOnline } = useIsOnline();

  // Enable offline redirect functionality across all pages
  useOfflineRedirect();

  return (
    <>
      <DirtyProvider>
        <DisabledPrinterProvider>
          <QmDetailsDialogProvider>
            <Header />
            {isOnline ? children : <SSCCOfflineCard />}
          </QmDetailsDialogProvider>
        </DisabledPrinterProvider>
      </DirtyProvider>
    </>
  );
}
